import React from "react";

const Faq = () => {
  return (
    <div>
      <h3>This is FAQ</h3>
    </div>
  );
};

export default Faq;
